module.exports = __webpack_public_path__ + "static/media/win-mic-disabled.a357e277.ico";